import Cookies from "js-cookie";

const TokenKey = "tele2_vue_token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function getRoleToken() {
  return Cookies.get("_ym_jwltone_10021");
}

export function setRoleToken(token) {
  return Cookies.set("_ym_jwltone_10021", token);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
